import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { Route } from "react-router-dom";
import { PATH_ANCILLARY_CUSTOMIZE } from "../../utils/paths";
import { PremierCollectionCustomize } from "./components";
import { PremierCollectionAncillaryConnectorProps } from "./container";
import { PORTAL_TITLE } from "../../lang/textConstants";

export interface IPremierCollectionAncillaryProps
  extends RouteComponentProps,
    PremierCollectionAncillaryConnectorProps {}

export const PremierCollectionAncillary = (
  props: IPremierCollectionAncillaryProps
) => {
  const { isCustomizePageEnabled } = props;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    return () => {
      document.title = PORTAL_TITLE;
    };
  }, []);

  return (
    <Box className="premier-collection-ancillary-root">
      {isCustomizePageEnabled && (
        <Route path={PATH_ANCILLARY_CUSTOMIZE}>
          <PremierCollectionCustomize />
        </Route>
      )}
    </Box>
  );
};
